import { render, staticRenderFns } from "./close-icon-black.vue?vue&type=template&id=11d4b1c0&scoped=true&lang=pug&"
import script from "./close-icon-black.vue?vue&type=script&lang=js&"
export * from "./close-icon-black.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d4b1c0",
  null
  
)

export default component.exports